/** Canonical pino level names in ascending severity order. */
export const PINO_LEVEL_NAMES = ["trace", "debug", "info", "warn", "error", "fatal"];
/**
 * Maps a level name to its pino numeric value. Single source of truth shared
 * by the frontend emitter and the API receiver.
 */
export const PINO_LEVELS = {
    trace: 10,
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
};
const REVERSE = {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal",
};
/** Resolve a pino numeric value to its level name; unknown values default to `info`. */
export function pinoLevelName(value) {
    return REVERSE[value] ?? "info";
}
/** Resolve a level name to its pino numeric value; unknown names default to `info`. */
export function pinoLevelNumber(name) {
    if (name in PINO_LEVELS)
        return PINO_LEVELS[name];
    return PINO_LEVELS.info;
}
//# sourceMappingURL=pino-levels.js.map